import {DataGridHeaderConfig} from "../../DynamicFormTypes.ts";
import React from "react";
import {getColSpan} from "../sharedStyles.tsx";
import {renderComponent} from "../../dyanimcFormUtil.tsx";
import { Star} from "lucide-react";

interface DataGridHeaderProps {
    config?: DataGridHeaderConfig
    useColumnLayout: boolean;
}

const DataGridHeaderRenderer: React.FC<DataGridHeaderProps> = ({
                                                                  config,
                                                                  useColumnLayout
                                                              }) => {
    if (!config || !config.components || config.components.length === 0) {
        return null;
    }

    const renderComponents = () => {
        return config.components.map((nestedComponent, _index) => {
            const item = {...nestedComponent, compactUI: true};
            return (
                <div
                    key={`data-grid-header-${item.fieldKey}`}
                    className={useColumnLayout ? `${getColSpan(nestedComponent.width || 12)}` : `${getColSpan(nestedComponent.width || 1)}`}
                >
                    {renderComponent(
                        {
                            component: item,
                        }
                    )}
                </div>
            )
        });
    }

    if (useColumnLayout) {
        return (
            <div className="">
                {/* Column header with item number and remove button */}
                <div className="bg-gray-200 px-4 py-2 flex justify-between items-center sticky top-0 z-10">
                    <div className="text-sm font-medium text-gray-700">
                        {config.label || 'Header'}
                    </div>
                    <button
                        type="button"
                        className={`
                        p-1.5 rounded-full text-yellow-500
                    `}
                        aria-label="Remove column"
                    >
                        <Star className="h-5 w-5" />
                    </button>
                </div>

                {/* Stack components vertically */}
                <div className={`p-2 bg-gray-100 min-h-[200px] grid grid-cols-12`}>
                    {renderComponents()}
                </div>
            </div>
        );
    }
    return (
        <>
            <div className={`bg-gray-100 rounded-lg shadow-sm`}>
                <div className="bg-gray-200 px-4 py-2 flex justify-between items-center">
                    <div className="text-sm font-medium text-gray-700">
                        Header
                    </div>
                    <button
                        type="button"
                        className={`
                            p-1.5 rounded-full text-yellow-500
                        `}
                        aria-label="Remove column"
                    >
                        <Star className="h-5 w-5" />
                    </button>
                </div>

                {/* Use CSS Grid for automatic layout */}
                <div className="grid grid-cols-12 gap-3 p-3">
                    {renderComponents()}
                </div>
            </div>
        </>
    )

}

export const DataGridHeader = React.memo(DataGridHeaderRenderer);